<!--<div class="flex justify-center w-full md:mt-11 pb-8">-->
<!--    <img src="assets/icons/Icons/other-payment-options/google-pay-mark.png" alt="googlepay logo">-->
<!--</div>-->
<!--<div class="w-full">-->
<!--    <p class="my-6">Pay seamlessly and securely using Google Pay&#33;</p>-->
<!--    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">-->
<!--        <b class="col-span-1">Step 1:</b>-->
<!--        <p class="col-span-3 md:col-span-5">If you are logged into your Google Account, your information will be pre-filled. Otherwise you will be asked to log in.-->
<!--&lt;!&ndash;          <b>Continue</b> or select another card and tap <b>Continue</b></p>&ndash;&gt;-->
<!--    </div>-->
<!--    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">-->
<!--        <b class="col-span-1">Step 2:</b>-->
<!--        <p class="col-span-3 md:col-span-5">Your transaction will be authenticated </p>-->
<!--    </div>-->
<!--    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">-->
<!--        <b class="col-span-1">Step 3:</b>-->
<!--        <p class="col-span-3 md:col-span-5">The payment will be processed </p>-->
<!--    </div>-->
<!--</div>-->
<div class="flex justify-center w-full md:mt-11 pb-8">
  <img class="w-3/5 md:w-1/4 cursor-pointer" src="assets/icons/Icons/other-payment-options/google-pay-mark.png" alt="googlepay logo" (click)="selectMethod($event)">
</div>
<div class="w-full">
  <p class="my-6">Pay seamlessly and securely using Google Pay&#33;</p>

  <h3 class="font-bold mb-2">For users logged in to their Google account:</h3>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 1:</b>
    <p class="col-span-3 md:col-span-5">Click on the Google Pay button.</p>
  </div>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 2:</b>
    <p class="col-span-3 md:col-span-5">Review your payment details and shipping information in the pop-up window.</p>
  </div>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 3:</b>
    <p class="col-span-3 md:col-span-5">Click "Pay" or "Confirm" to complete the transaction.</p>
  </div>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 4:</b>
    <p class="col-span-3 md:col-span-5">Authenticate the payment if prompted.</p>
  </div>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 5:</b>
    <p class="col-span-3 md:col-span-5">Wait for the payment to be processed and see the confirmation screen.</p>
  </div>

  <h3 class="font-bold mt-6 mb-2">For users not logged in to their Google account:</h3>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 1:</b>
    <p class="col-span-3 md:col-span-5">Click on the Google Pay button.</p>
  </div>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 2:</b>
    <p class="col-span-3 md:col-span-5">Sign in to your Google account when prompted.</p>
  </div>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 3:</b>
    <p class="col-span-3 md:col-span-5">Select your desired payment method and shipping address.</p>
  </div>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 4:</b>
    <p class="col-span-3 md:col-span-5">Review the payment details and click "Pay" or "Confirm".</p>
  </div>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 5:</b>
    <p class="col-span-3 md:col-span-5">Authenticate the payment if prompted.</p>
  </div>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 6:</b>
    <p class="col-span-3 md:col-span-5">Wait for the payment to be processed and see the confirmation screen.</p>
  </div>
</div>
